import React from 'react';
import {Plugins, type AtomRenderProps, Atom} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import CodeBlockSyntaxHighlighter from './CodeBlockSyntaxHighlighter';

// eslint-disable-next-line webflow/module-top-level-imports
import {withLlmRender} from '@packages/utilities/llm-wfdl-renderer/withLlmRender';

const getLockedStyleMessage = (style: string) =>
  `The code block ${style} property can't be changed.`;

const CodeBlock = Atom.createRender(
  withLlmRender(
    ({attributes, classes, generateAttributes, data}: AtomRenderProps) => {
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      const {code, language, theme, lineNumbers = false} = data;

      const wrapperClasses = classes.push('w-code-block');
      const elementProps = generateAttributes(attributes, wrapperClasses);

      return (
        <CodeBlockSyntaxHighlighter
          code={code || ''}
          elementProps={elementProps}
          language={language}
          lineNumbers={lineNumbers}
          theme={theme}
        />
      );
    },
    'pre'
  )
);

const config = Atom.create({
  displayName: 'Code Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('CodeBlock')),
  },
  showEmpty: false,
  render: CodeBlock,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Basic'), typeName('CodeBlock'))
  ),
  lockedStyles: {
    display: {
      when: true,
      message: getLockedStyleMessage('display'),
    },
    fontFamily: {
      when: true,
      message: getLockedStyleMessage('font'),
    },
    color: {
      when: true,
      message: getLockedStyleMessage('color'),
    },
    wordBreak: {
      when: true,
      message: getLockedStyleMessage('word break'),
    },
    whiteSpace: {
      when: true,
      message: getLockedStyleMessage('line break'),
    },
    overflowWrap: {
      when: true,
      message: getLockedStyleMessage('wrap'),
    },
    backgroundImage: {
      when: true,
      message: getLockedStyleMessage('background image & gradient'),
    },
    backgroundColor: {
      when: true,
      message: getLockedStyleMessage('background color'),
    },
    paddingBottom: {
      when: true,
      message: getLockedStyleMessage('padding bottom'),
    },
    paddingLeft: {
      when: true,
      message: getLockedStyleMessage('padding left'),
    },
    paddingRight: {
      when: true,
      message: getLockedStyleMessage('padding right'),
    },
    paddingTop: {
      when: true,
      message: getLockedStyleMessage('padding top'),
    },
  },
});

export default config;
